import { ProgramThumbnailGroup } from '@type/buzzkuri/program-detail'
import { RecommendTrainingProgramHeading } from './Heading'
import { RecommendTrainingProgramList } from './List'

type Props = {
  heading: string
  recommendPrograms: ProgramThumbnailGroup
}

export const RecommendTrainingProgram = ({
  recommendPrograms,
  heading,
}: Props): JSX.Element => {
  return (
    <div className="flex flex-col">
      <RecommendTrainingProgramHeading {...{ heading }} />
      <RecommendTrainingProgramList {...{ recommendPrograms }} />
    </div>
  )
}
